  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
  import ListItemText                                        from '@material-ui/core/ListItemText';
  import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
  import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';

  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_RegisterGOVService }                           from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import SettingsMainStyle                                   from "./SettingsMainStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import WU_CONTENT_user_avatar                              from "assets/img/wu/WU_CONTENT_user_avatar.svg";
//import WU_FORM_arrow_right_forward                         from "assets/img/wu/WU_FORM_arrow_right_forward.svg";
  //----------
  // variables
  //----------
  const filename = "SettingsMain ";
  const Transition = React.forwardRef(function Transition(props, ref) {
   return <Slide direction="up" ref={ref} {...props} />;
  });

  //[Lockers]
  var SettingsMain_continue_locked = true;

class SettingsMain extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      userFullName                                         : "-",
      userEmail                                            : "-",
      userAddress1                                         : "-",
      userAddress2                                         : "-",
      userAddress3                                         : "-",
      userPhone                                            : "-",

      documentDetails_hidden                               : false,

      redirectURL                                          : "", //GOV info
      languageCode                                         : "",

      //popup checkAppVersion
      dialog_checkAppVersion_isOpen                        : false,
      dialog_checkAppVersion_msg                           : "",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                             = this.isLockersActive.bind(this);
    this.startLockers                                                = this.startLockers.bind(this);
    this.stopLockers                                                 = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    this.findCountryNameFromCountryId                                = this.findCountryNameFromCountryId.bind(this);

    this.handleListItemClick0                                        = this.handleListItemClick0.bind(this); //SettingsProfile1
    this.handleListItemClick1                                        = this.handleListItemClick1.bind(this); //SettingsChangePass
    this.handleListItemClick2                                        = this.handleListItemClick2.bind(this); //SettingsTerms
    this.handleListItemClick2b                                       = this.handleListItemClick2b.bind(this); //SettingsTermsBills
    this.handleListItemClick3                                        = this.handleListItemClick3.bind(this); //SettingsPrivacy
    this.handleListItemClick4                                        = this.handleListItemClick4.bind(this); //SettingsChangeMobile
  //this.handleListItemClick_TEST                                    = this.handleListItemClick_TEST.bind(this); //SettingsChangeMobile
    this.handleListItemClick5                                        = this.handleListItemClick5.bind(this); //SettingsProfileIdDetails

    this.isWebAppIOS12x                                              = this.isWebAppIOS12x.bind(this);

    //popup checkAppVersion
    this.dialog_checkAppVersion_handleOpen                           = this.dialog_checkAppVersion_handleOpen.bind(this);
    this.dialog_checkAppVersion_btn_ok                               = this.dialog_checkAppVersion_btn_ok.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      //++++++++++++
      //Login Screen
      //++++++++++++
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
      return;
    }

    //-------------
    //Do some reset
    //-------------
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    //if(api.print_logs){console.log('cookie='+Cookies.set('testCookie',"test123"));}
    try { localStorage.setItem("LoginPage_flow",          "false"); } catch(err){;}
    try { localStorage.setItem("TransferOnlineLogin_flow","false"); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsMain"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCountries"        : res.countries });
        this.setState({ "parserObject_getCountries4Picker" : parserObject_getCountries4Picker });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------------
    //wu_validatecustomer
    //-------------------
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="SettingsMain"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      var documentDetails_hidden = false;
      let aTextDecision = wu_Utilities.textDecisions_customerLevel(api.print_logs,res.customer);
      if(aTextDecision === "LIGHT" || aTextDecision === "BP"){
        documentDetails_hidden = true;
      }
      if(api.new_registration_enabled===false){
        documentDetails_hidden = true;
      }



      this.setState({
        "userFullName"           : res.customer.fname+" "+res.customer.lname,
        "userEmail"              : res.customer.email,
        "userAddress1"           : res.customer.address,
        "userAddress2"           : res.customer.city,
      //"userAddress3"           : res.customer.countryResidence,
        "userPhone"              : res.customer.phone,
        "documentDetails_hidden" : documentDetails_hidden,
      });

      if(this.isWebAppIOS12x()){
        setTimeout(function() {
          let sel = document.getElementById('root');
          sel.style.display='none';
          sel.style.display='flex';
      //}.bind(this), 250);
        }.bind(), 250);
      }
      this.checkAppVersion();
    })
    .catch(err => {
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){
        if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
        this.dialog_handleOpen(err.returnText);
      }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  checkAppVersion(){
    let methName = filename+"checkAppVersion ";
    if(api.print_logs){console.log(methName);}

    //---------------
    //checkAppVersion---CACHED
    //---------------
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let retrieveWSData_checkAppVersion = wu_AppVersion.wu_should_checkAppVersion();
    if(retrieveWSData_checkAppVersion){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsMain"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        if(res.isMajorUpdate===true){
          this.dialog_checkAppVersion_handleOpen(res.returnText);
          return;
        }
        //this.nextMethod();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //this.nextMethod();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //this.nextMethod();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    try{
      let parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));
      this.setState({
      //"userFullName" : res.customer.name+" "+res.customer.lname,
      //"userEmail"    : res.customer.email,
      //"userAddress1" : res.customer.address,
      //"userAddress2" : res.customer.city,
        "userAddress3" : this.findCountryNameFromCountryId(parserObject_validatecustomer.countryResidence),
      //"userPhone"    : res.customer.phone,
      });
    } catch(err){ console.log(methName+"err="+JSON.stringify(err)); }
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container} ref={(ref) => this.section1 = ref}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("Settings_title")}</div>
              {/* <div className={classes.logo}><img src={logo} alt="logo" /></div> */}
            </div>

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.WU_CONTENT_user_avatar}><img src={WU_CONTENT_user_avatar} alt="" /></div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.userFullName}>{this.state.userFullName}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.userEmail}>{this.state.userEmail}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.logo}><img src={logo} alt="logo" /></div>
              </GridItem>
            </GridContainer>

            <div style={{ marginTop:10, marginBottom:10, "backgroundColor":"#EAEBED", padding:"0.8rem" }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}><div className={classes.userDetails}>{this.state.userAddress1}</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}><div className={classes.userDetails}>{this.state.userAddress2}</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}><div className={classes.userDetails}>{this.state.userAddress3}</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}><div className={classes.userDetails}>&nbsp;</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}><div className={classes.userDetails}>{this.state.userPhone}</div></GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>

            <div style={{marginBottom:20}}>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem onClick={this.handleListItemClick0} button>
                  <ListItemText primary={this.NSInforString("Settings_lbl_table1")} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
                {this.state.documentDetails_hidden === true ? ( "" ) : (
                  <React.Fragment>
                    <ListItem onClick={this.handleListItemClick5} button>
                      <ListItemText primary={this.NSInforString("Settings_lbl_table1b")} />
                      <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )}
                <ListItem onClick={this.handleListItemClick1} button>
                  <ListItemText primary={this.NSInforString("Settings_lbl_table2")} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
                {api.shouldUseSMSVerify202104 === false ? ( "" ) : (
                  <React.Fragment>
                    <ListItem onClick={this.handleListItemClick4} button>
                      <ListItemText primary={this.NSInforString("Settings_lbl_table2b")} />
                      <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                )}
                <ListItem onClick={this.handleListItemClick2} button>
                  <ListItemText primary={this.NSInforString("Settings_lbl_table5")} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
                <ListItem onClick={this.handleListItemClick2b} button>
                  <ListItemText primary={this.NSInforString("Settings_lbl_table5b")} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
                <ListItem onClick={this.handleListItemClick3} button>
                  <ListItemText primary={this.NSInforString("Settings_lbl_table6")} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                {/* <Divider />
                <ListItem onClick={this.handleListItemClick_TEST} button>
                  <ListItemText primary={"TEST"} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem> */}
              </List>
            </div>
          </GridItem>
        </GridContainer>

    {/* <GridContainer justify="center">
          <form id="govRedirectForm" action={api.url_onlinemt+api.webapp_path+"/gov/wbwu/redirect"} method="post">
            <GridItem xs={10} sm={10} md={10}> */}
              {/* GOV Payment info */}
          {/* <input type="hidden" id="redirectURL"                    name="redirectURL"                    value={this.state.redirectURL}/>
              <input type="hidden" id="languageCode"                   name="languageCode"                   value={this.state.languageCode}/> */}
              {/* Session between domains : webapp & mobile */}
          {/* <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
              <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/> */}
              {/* Session between domains : webapp */}
          {/* <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
              <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
            </GridItem>
          </form>
        </GridContainer> */}
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP checkAppVersion]------ */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_checkAppVersion_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_checkAppVersion_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_checkAppVersion_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_checkAppVersion} color="default" onClick={this.dialog_checkAppVersion_btn_ok}>{this.NSInforString("dialog_checkAppVersion_btn_ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //https://material-ui.com/components/lists/
  // function generate(element) {
  //   return [0, 1, 2].map(value =>
  //     React.cloneElement(element, {
  //       key: value,
  //     }),
  //   );
  // }

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleListItemClick0(event){
    let methName = filename+"handleListItemClick0 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    if(api.new_registration_enabled){
      //++++++++++++++++
      //SettingsProfile1
      //++++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("SettingsProfilePersonal"));
    }
    else{
      //++++++++++++++++
      //SettingsProfile1
      //++++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("SettingsProfile1"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick1(event){
    let methName = filename+"handleListItemClick1 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //++++++++++++++++++
    //SettingsChangePass
    //++++++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsChangePass"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick5(event){
    let methName = filename+"handleListItemClick5 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //++++++++++++++++++++++++
    //SettingsProfileIdDetails
    //++++++++++++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsProfileIdDetails"));

    // //let parserObject_validatecustomer = {};
    // //try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    // //var newRegistrationFlow = wu_Utilities.newRegistrationFlow_flag_get(api.print_logs,parserObject_validatecustomer);
    // try { localStorage.setItem("newRegistrationFlow","upgradeAccount"); } catch(err){;}
    // //++++++++++++++++++++
    // //SettingsChangeMobile
    // //++++++++++++++++++++
    // history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick4(event){
    let methName = filename+"handleListItemClick4 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //++++++++++++++++++++
    //SettingsChangeMobile
    //++++++++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsChangeMobile"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick2(event){
    let methName = filename+"handleListItemClick2 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //+++++++++++++
    //SettingsTerms
    //+++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsTerms"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick2b(event){
    let methName = filename+"handleListItemClick2b ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //+++++++++++++
    //SettingsTerms
    //+++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsTermsBills"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick3(event){
    let methName = filename+"handleListItemClick3 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //+++++++++++++++
    //SettingsPrivacy
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsPrivacy"));
  }
  //----------------------------------------------------------------------------------------------------
  // handleListItemClick_TEST(event){
  //   let methName = filename+"handleListItemClick_TEST ";
  //   if(api.print_logs){console.log(methName);}
  //
  //     //-------------
  //     //egov_redirect
  //     //-------------
  //     wu_RegisterGOVService
  //     .wu_egov_redirect({email:this.state.userEmail})
  //     .then(res => {
  //       if(localStorage.getItem("curr_view").trim()!=="SettingsMain"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
  //       /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
  //       localStorage.setItem("parserObject_egov_redirect",JSON.stringify(res));
  //       let redirectURL       = "";
  //       let languageCode      = "";
  //       let parserObject_egov_redirect = null;
  //       try{ parserObject_egov_redirect = JSON.parse(localStorage.getItem("parserObject_egov_redirect"));} catch(err){;}
  //       try{ redirectURL       = parserObject_egov_redirect["url"]; }catch(err){redirectURL = "";}
  //       languageCode           = localStorage.getItem("lang")==="en" ? "en-US" : "el-GR";
  //       this.setState({
  //         redirectURL                                          : redirectURL,
  //         languageCode                                         : languageCode,
  //       });
  //       setTimeout(function() { //Start the timer
  //         if (typeof document.getElementById('govRedirectForm').submit === "object") {
  //             document.getElementById('govRedirectForm').submit.remove();
  //         }
  //         document.getElementById('govRedirectForm').submit();
  //       }.bind(this), 500);
  //     })
  //     .catch(err => {
  //       this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
  //       console.log(methName+"err="+JSON.stringify(err));
  //       if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
  //       else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
  //     });
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  findCountryNameFromCountryId(countryId){
    for(let i=0; i<this.state.parserObject_getCountries.length; ++i){
      if(this.state.parserObject_getCountries[i].ctry_wu_id===countryId){
        if(localStorage.getItem("lang")==="en"){ return this.state.parserObject_getCountries[i]["descr_en"]; }
        else                                   { return this.state.parserObject_getCountries[i]["descr_el"]; }
      }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups checkAppVersion----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_checkAppVersion_isOpen" : true,
        "dialog_checkAppVersion_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_btn_ok(){
    window.location.reload(true);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( SettingsMain_continue_locked===true ){ return true;  }
    else                                        { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    SettingsMain_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    SettingsMain_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IOS12---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  isWebAppIOS12x() {
    let methName = filename+"isWebAppIOS12x ";
    try{
      let ua = window.navigator.userAgent;
      if (/iP(hone|od|ad)/.test(ua)) {
        var v = (ua).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10);
        console.log(methName+"iOS version="+parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10));
        if(parseInt(v[1], 10)===12){
          return true;
        }
      }
    }catch(err){
      console.log(methName+"err="+err);
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
}
SettingsMain.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(SettingsMainStyle)(SettingsMain)
);
